export default __webpack_public_path__ + "static/media/404-walker.1b92332b.png";